import { TAO_KOE } from './../libs';

class Countdown {
	constructor( countdownEl ) {
		this.countdownEl = countdownEl;

		this.format = this.countdownEl.getAttribute( 'data-format' ) || '%dd | %hh | %ii | %ss';
		this.finish = this.countdownEl.getAttribute( 'data-finish' ) || '';

		this.date = new Date( this.countdownEl.getAttribute( 'data-time' ) );
		this.interval = setInterval( () => this.update(), 500 );
	}

	update() {
		// Set the date we're counting down to
		const countDownTime = this.date.getTime();

		// Get todays date and time
		const now = new Date().getTime();

		// Find the distance between now an the count down date
		const distance = countDownTime - now;

		// Time calculations for days, hours, minutes and seconds
		const time = {
			'd': Math.floor( distance / ( 1000 * 60 * 60 * 24 ) ),
			'h': Math.floor( ( distance % ( 1000 * 60 * 60 * 24 ) ) / ( 1000 * 60 * 60 ) ),
			'i': Math.floor( ( distance % ( 1000 * 60 * 60 ) ) / ( 1000 * 60 ) ),
			's': Math.floor( ( distance % ( 1000 * 60 ) ) / 1000 ),
		};

		let result = this.format;
		const symbol = [ 'd', 'h', 'i', 's' ];

		for ( const i in symbol ) {
			const short = symbol[ i ];
			result = result.replace( '%' + short, time[ short ] );
		}

		// Display the result in the element with id <?php echo json_encode( $id ); ?>;

		if ( result !== this.countdownEl.innerHTML ) {
			this.countdownEl.innerHTML = result;
		}

		// If the count down is finished, write some text
		if ( distance < 0 ) {
			this.onFinish();
		}
	}

	onFinish = function() {
		clearInterval( this.interval );
		this.countdownEl.innerHTML = this.finish;
	};

	static init( scopeEl = document ) {
		const countdownEls = Array.from( scopeEl.getElementsByClassName( 'tao-countdown' ) );
		countdownEls.forEach( ( countdownEl ) => {
			countdownEl.KOE_COUNTDOWN ??= new Countdown( countdownEl );
		} );
	}
}

// Initialise immediately.
Countdown.init();
TAO_KOE.ready( 'countdown.js', () => Countdown.init() );

// Expose.
TAO_KOE.Countdown = Countdown;
export default Countdown;
